export default __webpack_public_path__ + "static/media/Deacon's Helm of the Spilling Blood.83b24848.jpg";